// src/icons/PersonCircle.tsx
import { jsx, jsxs } from "@emotion/react/jsx-runtime";
function PersonCircle() {
  return /* @__PURE__ */ jsxs(
    "svg",
    {
      width: "100%",
      viewBox: "0 0 33 33",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ jsx(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3721 0.248047C7.46702 0.248047 0.248047 7.46702 0.248047 16.3721C0.248047 21.0432 2.2344 25.2505 5.40849 28.1952C8.28546 30.8642 12.1382 32.4961 16.3721 32.4961C20.6059 32.4961 24.4588 30.8642 27.3356 28.1952C30.5098 25.2505 32.4961 21.0432 32.4961 16.3721C32.4961 7.46702 25.2771 0.248047 16.3721 0.248047ZM6.65904 26.0413C8.79248 23.1022 12.1978 21.2093 16.3721 21.2093C20.5464 21.2093 23.9517 23.1022 26.085 26.0413C23.6032 28.5344 20.1678 30.0775 16.3721 30.0775C12.5763 30.0775 9.14095 28.5344 6.65904 26.0413ZM21.2093 13.1473C21.2093 15.8189 19.0437 17.9845 16.3721 17.9845C13.7005 17.9845 11.5349 15.8189 11.5349 13.1473C11.5349 10.4758 13.7005 8.31006 16.3721 8.31006C19.0437 8.31006 21.2093 10.4758 21.2093 13.1473Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ jsx(
          "path",
          {
            d: "M6.49756 25.9241L6.39773 26.0617L6.51763 26.1821C9.03545 28.7113 12.5211 30.277 16.3721 30.277C20.223 30.277 23.7087 28.7113 26.2264 26.1821L26.3463 26.0617L26.2465 25.9241C24.076 22.9339 20.611 21.0098 16.3721 21.0098C12.1332 21.0098 8.66814 22.9339 6.49756 25.9241ZM27.1999 28.0489L27.3356 28.1952L27.1999 28.0489C24.3585 30.685 20.5536 32.2966 16.3721 32.2966C12.1905 32.2966 8.38573 30.685 5.5442 28.0489C2.4091 25.1403 0.447582 20.9854 0.447582 16.3721C0.447582 7.57722 7.57722 0.447582 16.3721 0.447582C25.1669 0.447582 32.2966 7.57722 32.2966 16.3721C32.2966 20.9854 30.3351 25.1403 27.1999 28.0489ZM16.3721 18.184C19.1539 18.184 21.4088 15.9291 21.4088 13.1473C21.4088 10.3656 19.1539 8.11053 16.3721 8.11053C13.5903 8.11053 11.3353 10.3656 11.3353 13.1473C11.3353 15.9291 13.5903 18.184 16.3721 18.184Z",
            stroke: "white",
            strokeOpacity: "0.05",
            strokeWidth: "0.39907"
          }
        )
      ]
    }
  );
}

export {
  PersonCircle
};
